export default __webpack_public_path__ + "static/media/_DSC0132.8abd44cb.JPG";